import React, { useState } from "react";
import { DashboardEditorProps } from "components/ComponentType";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import CommonChartEditor from "../../CommonChartEditor";
import { DatasetChartProps } from "../../interfaces";

function HistogramChartEditor({ config, onConfigChange }: DashboardEditorProps<DatasetChartProps>) {
  const [referenceTime, setReferenceTime] = useState(() => {
    if (config.referenceTime === undefined) {
      return new Date();
    }
    return new Date(config.referenceTime);
  });
  const onReferenceTimeChange = (e: Date | undefined) => {
    if (!e) return;
    const isoString = e.toISOString();
    setReferenceTime(e);
    onConfigChange({ ...config, referenceTime: isoString });
  };
  return (
    <div>
      <div className="flex flex-column gap-2 mb-3">
        <label htmlFor="referenceTime">Reference Time</label>
        <CalendarWrapper
          id="referenceTime"
          value={referenceTime}
          onChange={onReferenceTimeChange}
          className="p-mr-2 w-3"
          debounceTimeInMs={300}
        />
      </div>
      <CommonChartEditor config={config} onConfigChange={onConfigChange} />
    </div>
  );
}
export default HistogramChartEditor;
